/* eslint-disable max-len */

export default {
  lang: 'Español',
  homeScreen: {
    title: '',
    stayConnected: 'Mantente Conectado',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
    subtitle: 'Vive Boricua',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Algo salió mal. Por favor, inténtelo de nuevo más tarde.',
    },
    programStatus: {
      title: 'Mi estado',
      loading: 'Cargando…',
      yourRep: 'Su rep',
      myProfile: 'perfil',
      favorites: 'Favoritos',
      registeredOn: 'Se unió el:',
      graduatedOn: 'Graduó el:',
      totalBadgesEarned: 'Total de insignias obtenidas:',
      lastBookingLogged: 'Última reserva registrada:',
      currentTier: 'Nivel actual',
      lastBadgeEarned: 'Última insignia obtenida:',
      currentFocus: 'Enfoque actual:',
    },
    todaysfocus: {
      title: 'Enfoque de hoy',
      empty: 'No hay elementos de enfoque para hoy',
      loading: 'Cargando…',
      error: 'Algo salió mal',
      slideNavAria: 'Navegación de diapositivas',
      slideAria: 'Diapositiva',
      carouselAria: 'Enfoque de hoy',
    },
    welcome: '¡Bienvenido!',
    welcomeBack: '¡Bienvenido de nuevo, {firstName}!',
    notifications: {
      loading: 'Cargando…',
      empty: 'No hay notificaciones',
    },
    achievements: {
      title: 'Recompensas y concursos',
      loading: 'Cargando…',
      lastBooking: 'Último envío de entrada',
      currentTier: 'Nivel actual',
      contestEntries: 'Total de participaciones en concursos',
      nightsBooked: 'Noches reservadas',
      totalRevenue: 'Ingresos totales reportados',
      noBookingData: 'No hay datos de reservas disponibles.',
      fileUploadSuccess: 'El archivo se ha subido correctamente.',
      quickSubmit: {
        title: 'Envío rápido',
        uploading: 'Subiendo…',
        clear: 'Borrar',
        submit: 'Enviar',
        submitSuccessSimulated: 'Reserva enviada correctamente',
      },
    },
  },
  profileImageView: {
    currentImage: 'Tu imagen de perfil actual:',
    uploadImage: 'Sube tu imagen de perfil:',
    chooseAFile: 'Elige un archivo…',
    cancel: 'cancelar',
    backButton: 'Regresar',
    uploadButton: 'Subir imagen de perfil',
    saveButton: 'Guardar esta imagen de perfil',
    fileTooLargeTitle: 'Tamaño de carga excedido',
    fileTooLargeText: 'El tamaño máximo de carga de imagen es 10mb',
  },
  notification: {
    newAndNow: '¡Nuevo y Ahora!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Nueva Insignia',
    'content-update': 'Actualización de Contenido',
    events: 'Eventos',
    other: 'Notificación',
    welcome: 'Bienvenido',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos a ver si podemos encontrar un perfil existente para ti en nuestro sistema.',
      homeTitleSub:
        'Introduce la dirección de correo electrónico que normalmente usas para iniciar sesión en programas de capacitación.',
      noAccount:
        'No se encontró ninguna cuenta ({email}), por favor intenta con otro correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success:
        '¡Cuenta actualizada con éxito! Serás redirigido a la página de inicio en breve.',
      successNewAccount:
        'Para completar tu registro, recibirás un correo electrónico de confirmación para verificar tu cuenta.',
      loginButton: 'Iniciar Sesión',
      matchFound:
        'Hemos encontrado una coincidencia, por favor introduce tu contraseña para continuar.',
      magicLink:
        'Iniciar sesión a través de un enlace en tu correo electrónico:',
      magicLinkButton: 'Solicitar Enlace Mágico',
      magicLinkTitle:
        'Recibe un enlace directo en tu correo electrónico que te permitirá iniciar sesión al instante.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, tómate un momento para completar toda la información a continuación ya que se utilizará para tu perfil personal y tu información de contacto.',
      titleIndustry:
        'Por favor, tómate un momento para completar toda la información a continuación ya que se utilizará para tu perfil personal y tu información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de Viajes',
      visitor: 'Visitante de la Industria',
      step1: 'Paso 1: Tipo de Usuario',
      step2: 'Paso 2: Crear una Cuenta',
      step3: 'Paso 3: Crear tu Perfil',
      marketingOptIn:
        '¿Estás seguro de que no estás interesado en mantenerte conectado con el equipo de trade de este programa?',
      optIn: 'Sí, estoy interesado',
      optOut: 'No interesado',
      step2Sub1: 'Cuéntanos sobre ti',
      step2Sub2: 'Cuéntanos sobre tu empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marca las casillas a continuación para asegurarte de recibir comunicaciones importantes del equipo de trade del proveedor (actualizaciones de productos y anuncios, recompensas, incentivos, FAMs, etc.) y las iniciativas de networking y soporte de ventas de TravPRO Mobile.',
      privacy:
        'Protegemos tu privacidad y nunca vendemos, abusamos ni traicionamos tu confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'IMPULSADO POR',
      toastMessage: {
        forgotSuccess:
          '¡Hemos enviado un enlace de restablecimiento de contraseña a tu correo! Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting:
          'La dirección de correo electrónico que ingresaste no existe.',
        magicLinkMessage:
          'Por favor espera, te estamos iniciando sesión ahora mismo.',
        magicLinkError:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkError1:
          'No pudimos encontrar un token válido, por favor inicia sesión o solicita un nuevo enlace mágico. Si este problema persiste, por favor contáctanos en: info@travpromobile.com.',
        magicLinkError2:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkSuccess:
          'Revisa tu correo en {email}. Tiene un enlace mágico que te permitirá iniciar sesión.',
        magicLinkErrorWait:
          'Por favor espera 5 minutos entre solicitudes de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ingresaste no se puede encontrar en nuestros registros. Por favor revisa que no haya errores tipográficos o crea una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código Postal no encontrado, intenta de nuevo',
        zipCodeOnlyNumbers: 'El Código Postal solo puede contener números',
        password: 'Por favor introduce una contraseña',
        passwordNotMatching: 'Las contraseñas que ingresaste no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o es inválida. Por favor intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta.',
        fillInAllFields: 'Por favor completa todos los campos requeridos',
        fillInEmail: 'Por favor introduce tu correo electrónico.',
        emailNotExisting:
          'La dirección de correo electrónico que ingresaste no existe.',
      },
      fields: {
        forgotSubCopy: '¿Olvidaste tu contraseña y quieres cambiarla?',
        forgotSubCopy2:
          '¿Quieres omitir la contraseña por completo? Te enviaremos un correo electrónico con un enlace mágico que te permitirá iniciar sesión automáticamente en el programa.',
        city: 'Ciudad',
        companyName: 'Nombre de la Empresa',
        role: 'Tu Rol',
        description: '¿Cuál describe mejor el negocio de tu empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elige una Contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar Contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido',
        agency: 'Nombre de tu Agencia',
        title: 'Tu Rol (Selecciona Uno)',
        company: 'Nombre de la Empresa',
        select: 'Selecciona una opción a continuación',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código Postal',
        postalCode: 'Código Postal',
        affiliate: '¿A qué grupo pertenece principalmente tu agencia?',
        hostAgency: 'Tu Agencia Anfitriona',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        other: 'Otro',
        opt: 'Mantente conectado con el equipo de trade de este programa y recibe actualizaciones.',
        optMarketing:
          'Mantente conectado con TravPRO sobre programas y eventos similares.',
        retail: 'Tienda Minorista',
        home: 'Agente Basado en Casa',
        independent: 'Contratista Independiente',
        host: 'Agencia Anfitriona',
        call: 'Centro de Llamadas o Agencia en Línea',
        describes: '¿Qué describe mejor a ti y al negocio de tu agencia?',
      },
    },
    title:
      'Programa de Capacitación y Habilitación de Ventas para Profesionales de Viajes',
    welcome: {
      headerTop: 'Bienvenido al',
      headerBottom:
        'Programa de Especialistas en Viajes a la Isla de Galveston',
    },
    sellingPoints: {
      0: 'Aprende, Promueve y Vende en Movimiento',
      1: 'Capacitación Multimedia en Dispositivos',
      2: 'Certificado de Finalización',
      3: 'Presentaciones de Ventas Prefabricadas',
      4: 'Materiales Promocionales de Alto Impacto',
      5: 'Consejos y Promociones Internas',
      6: 'Directorio de Productos en Tiempo Real',
      7: 'Noticias y Actualizaciones Oportunas',
    },
    emailPrompt:
      'Por favor introduce tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.',
    tAndC: {
      agree: 'Al continuar, aceptas nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      what: '¿Qué tipo de viajes vendes?',
      what1: '¿Cuál es el tipo #1 de viajes que vendes?',
      what2: '¿Cuál es el tipo #2 de viajes que vendes?',
      what3: '¿Cuál es el tipo #3 de viajes que vendes?',
      agency: 'Agencia *',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      passwordConfirm: 'Confirma tu contraseña *',
      firstName: 'Nombre *',
      lastName: 'Apellido *',
      agencyName: 'Nombre de la Agencia *',
      city: 'Ciudad *',
      stateProvince: 'Estado / Provincia *',
      salutation: 'Saludo *',
      required: 'Requerido',
      invalidEmail: 'Dirección de correo electrónico inválida',
      opt: '¡Mantente en contacto! Sí, me gustaría recibir comunicaciones de Visit Galveston que me mantendrán informado sobre noticias, eventos, incentivos, FAM’s y más.',
      complete: 'Paso 2: Completa tu perfil',
      tell: 'Cuéntanos sobre ti',
      title: 'Título Comercial *',
      host: 'Nombre de la Agencia Anfitriona',
      country: 'País / Región',
      select: 'Por favor selecciona una opción a continuación',
      header2: '¿Qué segmento(s) vendes principalmente?',
      step2: 'Describe tu negocio',
      leisure: 'Ocio',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: '¿Cuál es tu afiliación principal?',
      forgot:
        '¿Olvidaste tu contraseña? Haz clic en el botón a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy un asesor',
      title: 'Gracias por tu interés en\nVisit Galveston',
      messageWeb:
        'El contenido de este sitio es exclusivamente para profesionales de viajes.\nPara obtener más información sobre Visit Galveston, por favor visita: ',
      messageMobile:
        "Parte del contenido de esta aplicación es exclusivamente para profesionales de viajes, pero siéntete libre de explorar una vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.",
      continue: 'Continuar',
      visitWebsite: 'Visitar sitio web',
    },
    newUser: 'Nuevo Usuario',
    register: 'Registrar',
    registered: 'Este correo ya está registrado',
    forgot: 'Restablecer Contraseña',
    header:
      'Por favor tómate un momento para completar toda la información a continuación, ya que se utilizará para tu perfil y tu información de contacto.',
    step1:
      'Paso 1: Completa tu dirección de correo electrónico y elige una contraseña.',
  },
  welcomeScreen: {
    title:
      'Bienvenido al Programa de Especialistas en Viajes a la Isla de Galveston',
    helloUser: 'Hola {{name}}',
    hello: 'Hola,',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    introOnline:
      'Capacítate inmediatamente en línea o precarga el contenido para que siempre esté disponible sin conexión.',
    introOffline:
      'Ya tienes la última versión precargada. Comienza a capacitarte o vender en cualquier momento y lugar.',
    startTraining: 'Comienza a aprender',
    continueTraining: 'Continúa aprendiendo',
    graduated: '¡Felicitaciones!',
    downloader: {
      preload: 'Precargar',
      stop: 'detener',
      init: 'Inicializando...',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Completo',
    unlock:
      'Desbloquea este capítulo completando el capítulo de capacitación {number}.',
    unlockSpecialization: 'Desbloquea este capítulo completando La Fundación',
    unlockSubtitle:
      'Desbloquea más capítulos completando capítulos de capacitación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Has llegado al final',
    retainEnd:
      'Usa la barra superior para navegar en este capítulo o presiona el botón de retroceso para regresar a la vista general.',
    watchListenRead: 'Mira, Escucha y Lee más',
    trouble:
      'Parece que tienes problemas, por favor vuelve a leer el contenido en las páginas anteriores e inténtalo de nuevo.',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor elige una respuesta',
    skip: 'Regresar >',
    viewAllTitle: 'Consejo de Capacitación',
    viewAll:
      'Para proceder a la siguiente página, haz clic en los íconos para ver el contenido complementario. Videos, mapas y otra información útil se han proporcionado para mejorar tu capacitación y asegurarte de que logres el estado PRO.',
    fillBlanks: 'Completa el(los) espacio(s) en blanco:',
    next: 'Siguiente pregunta',
    retry: 'Inténtalo de nuevo',
    fastTrackText: {
      success:
        'Felicidades, has aprobado el curso de Vía Rápida y desbloqueado el resto de la capacitación.',
      failed:
        'Lamentablemente no aprobaste el curso de Vía Rápida, puedes reanudar tu capacitación para obtener tu diploma.',
    },
    fastTrack: '¡Conviértete en una Superestrella de Viajes Suizos!',
    fastTrackExplanation:
      'Simplemente responde el cuestionario en las páginas siguientes para tu oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas del cuestionario de las siguientes maneras:</span><br><br>1.	El contenido que aprendiste en los módulos de Rail Europe y Suiza<br><br>2.	Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos en detalle antes de tomar el cuestionario! Solo aquellos con las puntuaciones más altas tendrán la oportunidad de ser invitados al FAM.</span>',
    fastTrackButton:
      'Haz clic aquí para realizar el cuestionario de Superestrella Suiza',
    grading: 'Tu calificación final es: {grade}%',
    badge: 'descargar \n insignia',
  },
  nav: {
    home: 'Inicio',
    train: 'Capacitacion',
    learn: 'Aprender',
    retain: 'Retener',
    directory: 'Directorio',
    showRoom: 'Exposiciones',
    showcases: 'Exposiciones',
    offers: 'Ofertas',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    media: 'Medios',
    favorites: 'Favoritos',
    contact: 'Conoce al Equipo',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configuración de la Cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Capacitacion',
    retain: 'Retener',
    subapps: 'Módulos de Socios Especialistas en Viajes a la Isla de Galveston',
    maintrainings: 'La Fundación',
    subtrainings: 'La Experiencia',
  },
  pageDescriptions: {
    train: 'Edúcate, involúcrate y conviértete en el experto.',
    showroom: '',
    retain:
      'Bienvenido a Retener. Una vez completada la formación, este será su recurso de referencia para conservar sus conocimientos especializados y potenciar sus esfuerzos de ventas. Utilice esta área para responder con pericia a preguntas sobre productos o incluso como presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote:
      'Comparte estos elementos para despertar interés y comenzar una conversación con clientes y prospectos.',
    sell: 'Responde las preguntas de los clientes y cierra la venta como un profesional con recursos profundos y soporte de ventas dirigido.',
    favorites: 'Revisa tu contenido favorito personal',
    search: 'Busca en todo el contenido',
    subapps: '',
    maintrainings:
      'Completa estos módulos esenciales para obtener tu certificado.',
    subtrainings:
      'Perfeccione sus conocimientos y obtenga una insignia por cada módulo de especialización que se indica a continuación.',
  },
  general: {
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para: {{query}}',
    noFavorites: 'Aún no tienes favoritos.',
    noMessages: '¡Aún no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡Página 404 No Encontrada!',
    oops: 'Uh oh...',
    overview: 'Volver a la vista general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo Completo!',
    chapterComplete: '¡Capítulo Completado!',
    message: '{count} Mensaje',
    messagePlural: '{count} Mensajes',
    comingSoon: 'Próximamente',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Colección',
    layout: 'Diseño',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Colección',
  },
  questions: {
    dials: 'Gira los diales para que coincidan con la respuesta',
    fitb: 'Completa el(los) espacio(s) en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la(s) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Responde a la pregunta tocando el lugar correcto en el mapa',
    dropdown: 'Elige...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo Electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Optar por no participar',
    settings: 'Configuración de Privacidad',
    message:
      '¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Eso está bien, pero nos gustaría ofrecerte la mejor experiencia usando el Sales Companion.',
    disabled: 'Parece que has deshabilitado el uso de cookies.',
    use: 'La {{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.',
    details: '¿Para qué se usan las cookies?',
    enable: 'Mira cómo habilitar tus cookies {{aquí}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar Enlace',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Disfruta de la experiencia completa en la aplicación',
    body: 'Descarga la aplicación tocando uno de los botones de abajo, o busca "{appName}" en tu tienda de aplicaciones.',
    benefits: {
      header: 'Con la aplicación puedes:',
      1: 'Capacitarte en cualquier momento y lugar, incluso sin Wi‑Fi',
      2: 'Acceder a herramientas y recursos de ventas en un solo lugar',
      3: 'Continuar donde lo dejaste en cualquier dispositivo',
    },
    desktop: '¿Prefieres una pantalla más grande? Visita {link} desde tu computadora de escritorio o portátil.',
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    subFilters: 'Subfiltros',
    subFilter: 'Subfiltro',
    resetFilters: 'Restablecer Filtros',
    showResults: 'Mostrar Resultados',
    noResults:
      'No se encontraron resultados. Por favor intenta con otra búsqueda.',
    resetMap: 'Restablecer Mapa al Inicio >',
    viewNow: 'Ver Ahora >',
  },
  directory: {
    artsentertainment: 'Artes y Entretenimiento',
    conventionservices: 'Servicios de Convenciones',
    divingsnorkeling: 'Buceo y Snorkel',
    film: 'Cine',
    hotels: 'Hoteles',
    lgbtgymsandspas: 'LGBT+: Gimnasios y Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Dónde Alojarse',
    multiculturaldining: 'Multicultural: Comida',
    multiculturalnightlife: 'Multicultural: Vida Nocturna',
    nightlife: 'Vida Nocturna',
    petfriendly: 'Amigable con Mascotas',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    sports: 'Deportes',
    transportation: 'Transporte',
    venues: 'Lugares',
    waterways: 'Vías Navegables',
    waystoplay: 'Maneras de Jugar',
    weddinglocations: 'Lugares para Bodas',
    weddingvendors: 'Proveedores de Bodas',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Yo soy un...',
    brandAmbassador: 'Embajador de Marca',
    travelPro: 'Profesional de Viajes',
  },
  rewards: {
    rewards: 'Recompensas',
    title: 'Bienvenido al Centro de Recompensas',
    subheader: 'Rastrea y Comparte Envíos de Reservas y Recompensas',
    subTitle:
      '¡Te damos la oportunidad de ganar recompensas por convertirte en especialista con nuestro programa y reservar viajes a la Isla de Galveston!',
    body: '¡Reserva viajes a la Isla de Galveston para tener la oportunidad de ganar! Introduce tus reservas para ser elegible para ganar una Recompensa de Incentivo de Introducción de una Tarjeta de Regalo Electrónica de $5 US/CAN.',
    item1:
      'Después de tu primera reserva confirmada de 4 noches o más, (para una reserva individual), para un mínimo de dos (2) pasajeros, en un hotel/resort calificado. (Los cruceros no califican).',
    item2:
      'Oferta válida después de completar los Módulos Esenciales del Programa de Especialistas en Viajes a la Isla de Galveston.',
    link1: '¿Has reservado Isla de Galveston?',
    link2: 'Si es así, introduce tu reserva aquí.',
    button: 'Introduce tu reserva',
    products: 'Mercado',
    viewAllBookings: 'Reservas',
    viewLeaderboard: 'Tabla de Líderes',
    viewDashboard: 'Panel de Puntos',
    viewRewards: 'Visión General',
    overview: {
      title:
        'Gana Puntos y Recompensas en Efectivo por tu capacitación, compartir y reservas en Visit Galveston.*',
      grand: 'Recompensas en Efectivo por Cada Reserva de Más de 3 Noches',
      grandPrize: 'USD $50 por cada estancia de 3-5 noches',
      grandPrizeSecond: 'USD $100 por cada estancia de 6+ noches',
      first: 'Premios Mensuales',
      firstPrize:
        'Oportunidades de ganar parte de $500 para los asesores de viajes que reserven el mayor número de huéspedes a cualquier propiedad de Visit Galveston.',
      second: 'Premios Principales',
      secondPrize:
        'Habitaciones, Mejoras, Inspección de Sitios FAM, Merchandising y más para sorprender y deleitar a nuestros valiosos asesores.',
      choosen: 'Mercado de Canje de Puntos',
      choosenPrize:
        'Usa los puntos que ganas en todas las actividades, incluidas las introducciones de reservas, la capacitación y compartir materiales con tus clientes.',
      valid:
        '*Las reservas introducidas son válidas solo después de que se complete el viaje del cliente.',
    },
    home: {
      entries: 'Entradas Actuales',
      trainingAchievements: 'LOGROS DE CAPACITACIÓN',
      trainingAchievementsText:
        'Rastrea tu progreso de capacitación, certificaciones y estado de recompensas metálicas en esta página. También podrás descargar y compartir tu diploma de Especialista en Viajes de Visit Galveston, así como cualquier insignia que hayas ganado en Experiencias y Especializaciones de Socios.',
      bookingContests: 'PANEL DE RESERVAS',
      bookingContestsText:
        'Rastrea y gestiona fácilmente las introducciones de reservas actuales en el Panel de Reservas.',
      submitBooking: 'INTRODUCIR RESERVAS',
      submitBookingText:
        'Aquí es donde introducirás las reservas para ser incluidas en concursos de reservas.',
      currentContest: 'CONCURSO ACTUAL',
      currentContests: 'CONCURSOS ACTUALES',
      contestHeader: '¡Gana premios en efectivo en reservas cada mes!',
      contestPrizes:
        'Introduce tus reservas de hoteles, servicios terrestres y alquiler de autos cada mes para tener la oportunidad de ganar tres grandes premios:',
      contestPrize1: 'Una (1) Tarjeta de Regalo de $250',
      contestPrize1Description:
        ' se otorgará al asesor con el mayor número de reservas/entradas* del mes',
      contestPrize2: 'Dos (2) Tarjetas de Regalo de $100',
      contestPrize2Description:
        ' se otorgarán a dos asesores afortunados mediante un sorteo aleatorio',
      contestConditions: '*Una (1) Entrada se dará a cada reserva calificada:',
      contestLodging: '',
      contestCondition1: 'Las reservas deben ser de 3 noches o más',
      contestGroundServices: 'Servicios Terrestres:  ',
      contestCondition2:
        '3 servicios o más (por ejemplo, Meet & Greet, transferencia y turismo)',
      contestCarRental: 'Alquiler de Autos: ',
      contestCondition3: 'debe ser de 3 días o más',
      contestStartEarning:
        'Comienza a ganar tus oportunidades de ganar introduciendo ',
      contestEnterBookings: 'tus reservas',
      contestNow: ' ahora!',
      contestSeeOther: 'Ver otros ',
      contestTerms: 'Términos y Condiciones',
    },
    bookingRewardsView: {
      title: 'Mercado',
    },
    bookingsView: {
      title: 'Reservas',
    },
    leaderboardScreen: {
      title: 'PUNTOS \n Tabla de Líderes',
      earnedpts: 'MIS PUNTOS GANADOS​:',
      pointsWall: 'SEGUIMIENTO DE PUNTOS TOP 5​:',
      startEarning:
        "¡Comienza a ganar XP's ahora y únete a la tabla de líderes!",
      prizes: 'Premios',
      tAndC: 'Aplican términos y condiciones*',
      pointsOverview: {
        title: 'Cómo ganar puntos',
        booths: 'Visita Exposiciones de Expositores',
        breakoutSessions:
          'Asiste a Sesiones Divididas y Destacados de Destinos',
        trainingSessions: 'Completa un Capítulo de Capacitación',
        adventureSpotlights: 'Consejos de Viaje Familiar',
        share: 'Compartir Contenido',
        shareMax: '(hasta {maxSharePoints} puntos)',
        shareInfo:
          'Compartir se cuenta compartiendo contenido del stand en Twitter y Facebook o compartiendo todo el stand con colegas o clientes.',
        viewVideo: 'Ver Video',
      },
    },
    dashboardView: {
      title: 'Panel de Reservas',
      subtitle: 'Rastrea y Gestiona tus Entradas de Reservas Aquí.',
      badge: 'Insignias',
      activity: 'Panel de Reservas',
      manage: 'Gestionar Reservas',
      manageSub:
        'Ordena usando los botones arriba y haz clic en cualquier registro para gestionar los detalles de la introducción. Todas las entradas pendientes serán verificadas en 72 horas.',
      noBookings: 'No hay registros para mostrar.',
      state: {
        approvedEntries: 'Entradas Aprobadas',
        pendingEntries: 'Entradas Pendientes',
        declinedEntries: 'Entradas Rechazadas',
        viewAll: 'Ver Todo',
      },
    },
    bookingForm: {
      title: 'Formulario de Introducción de Reservas',
      subTitle: 'Introduce tu reserva:',
      required: '* Indica un campo obligatorio',
      email: 'Correo Electrónico del Asesor',
      agentFirstName: 'Nombre del Asesor',
      agentLastName: 'Apellido del Asesor',
      company: 'Nombre de la Empresa',
      iata: 'IATA/CLIA #',
      stateProvince: 'Estado/Provincia',
      postalCode: 'Código Postal *',
      country: 'País',
      bookingNumber: 'Número de Confirmación de Reserva',
      numberOfGuests: 'Número de Huéspedes Adultos',
      bookingDate: 'Fecha de Reserva',
      tourOperator: 'Operador Turístico / Método de Reserva',
      firstName: 'Nombre',
      lastName: 'Apellido del Huésped',
      accommodation: 'Resort/Hotel/Alojamientos reservados',
      select: 'Selecciona una opción',
      wholesaler:
        'Nombre del Mayorista (si aplica): si esta es una reserva directa, introduce NINGUNO',
      arrivalDate: 'Fecha de Check-In',
      departureDate: 'Fecha de Check-Out',
      lengthOfStay: 'Duración de la Estancia (en Noches)',
      reservationNumber: 'Número de Reserva',
      rooms: 'Número de Habitaciones',
      stay: 'Duración de la Estancia (en Noches)',
      airline: 'Aerolínea / Transportista (código de 2 dígitos)',
      originAirport: 'Puerta de Origen (código de 3 letras del aeropuerto)',
      destination: 'Destino/isla (código de 3 letras del aeropuerto)',
      cost: 'Costo Total de la Reserva (solo usa decimales)',
      file: 'Carga de Prueba RezSnap™',
      disclaimer: '* Campos obligatorios',
      button: 'Introduce tu reserva',
      sub: 'Tu información',
      sub2: 'Información de la reserva',
      guests: 'Número de Pasajeros',
    },
    TermsAndConditions: {
      title: 'Términos y Condiciones',
      subTitle: 'Recompensas Trimestrales para Especialistas en Bahamas',
      body1:
        'Todos los anuncios deben ir acompañados de un documento de prueba de venta con saldo cero que corresponda a cada reserva individual que hayas publicado. Los premiados serán seleccionados en función de la totalidad de los documentos de prueba de venta verificados que correspondan a cada reserva listada. Las publicaciones deben seguir todas las reglas del Programa de Especialistas en Viajes a la Isla de Galveston para ser elegibles.',
      body2:
        'Para ser elegible, debes residir en los EE. UU. y ser mayor de edad en el estado, provincia o territorio de residencia. Los empleados de los Operadores Turísticos NO son elegibles para los sorteos y NO serán considerados para premios adicionales. Los residentes de la Provincia de Quebec NO son elegibles para los sorteos y NO serán considerados para premios adicionales.',
      body3:
        'La emisión de recompensas puede requerir prueba de acreditación como asesor de viajes minorista/basado en casa. Las recompensas disponibles están sujetas a cambios durante el transcurso del programa.',
      body4: 'Privacidad y Uso de la Información Personal',
      body5:
        'Los agentes participantes (i) otorgan al Recompensador el derecho a usar su nombre, ciudad, estado, provincia, código postal, confirmación de mayoría de edad, número de teléfono y dirección de correo electrónico para, entre otros, contactar y anunciar a los premiados y la provisión de premios; (ii) otorgan al Recompensador el derecho a usar su información personal para fines de publicidad y promoción relacionados con los premios, en cualquier y todos los medios conocidos ahora o desarrollados en el futuro, sin compensación adicional a menos que lo prohíba la ley; y (iii) reconocen que el Recompensador puede divulgar su información personal a agentes y proveedores de servicios terceros en relación con cualquiera de las actividades enumeradas en (i) y (ii) anteriores.',
      button: 'Regresar a Recompensas',
    },
    thankYouPage: {
      thanks: 'Gracias',
      congrats: 'Felicitaciones, ',
      body: 'tu reserva ha sido recibida y enviada al supervisor de la campaña para su verificación.',
      link: 'Por favor, ten en cuenta que para ser un ganador, debes haber completado los Módulos Esenciales del Programa de Especialistas en Bahamas',
    },
    menu: {
      home: 'Centro de\nRecompensas',
      achievements: 'Logros de\nCapacitación',
      bookings: 'Panel de\nReservas',
      form: 'Introducir\nReservas',
    },
  },
  categories: {
    all: 'Todos',
    dining: 'Restaurantes',
  },
  badgeView: {
    title: 'Logros de Capacitación',
    subtitle:
      'Bienvenido a tu panel de Logros, donde puedes ver, seguir y descargar tus insignias de diploma y especialización.',
    badgeDisplayTitle: 'Estado de logro metálico',
    badgeAchievement:
      '¡Has alcanzado el estado {rank}! Haz clic en el icono de la derecha para ver y compartir tu estado.',
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Insignias de especialización',
    partnerBadges: 'Insignias de Socio',
  },
  badgeDisplay: {
    status: 'Nivel de formación alcanzado',
  },
};
